import { useState } from 'react';
import { Skeleton } from 'antd';
import { useCreateWorkerMutation, useUploadWorkerPhotoMutation } from 'app/services/workers';
import { useGetUnitQuery } from 'app/services/me';
import { Paths } from 'constants/index';
import { compressImage } from 'utils/file';
import WorkerForm, { toWorkerRequest } from './WorkerForm';

const CreateWorker = () => {
  const { data: unit, isLoading } = useGetUnitQuery({ persist: true });

  const [ createWorker, workerMeta ] = useCreateWorkerMutation();
  const [ uploadPhoto, photoMeta ] = useUploadWorkerPhotoMutation();
  const [ meta, setMeta ] = useState<any>({ isSuccess: false, data: {} });

  const handleSubmit = async (values: any) => {
    const worker = await createWorker(toWorkerRequest(values)).unwrap();

    const photo = (values.PhotoFile as any[] | undefined)?.[0];
    if (photo?.originFileObj) {
      const file = await compressImage(photo.originFileObj).catch(() => photo.originFileObj);
      // No unwrap: a failed upload doesn't undo the save, the exceptions middleware shows its toast.
      await uploadPhoto({ workerId: worker.Id, file });
    }

    setMeta({ isSuccess: true, data: { Id: worker.Id } });
  };

  if (!unit) return <Skeleton active={isLoading} />;

  return <WorkerForm
    handleSubmit={handleSubmit}
    unit={unit}
    meta={{
      isSuccess: meta.isSuccess,
      isLoading: workerMeta.isLoading || photoMeta.isLoading,
      isError: workerMeta.isError,
      error: workerMeta.error,
      data: meta.data
    }}
    redirectTo={Paths.WORKERS_VIEW}
  />;
};

export default CreateWorker;
